function formatHeroTagline() {
    (function($) {
        $(function() {
            const $tagline = $(".mg-hero__tagline");
            let taglineParts = $.trim($tagline.text()).split(".");

            if (taglineParts.length == 0) return;

            taglineParts.forEach((item, index) => {
                item = $.trim(item);
                if (item) {
                    taglineParts[index] = `${item}.`;
                } else {
                    taglineParts.splice(index, 1);
                }
            });

            taglineParts[0] = `<div>${taglineParts[0]}</div>`;
            $tagline.html(taglineParts.join(" "));
        });
    })(jQuery);
}

export default formatHeroTagline;



// WEBPACK FOOTER //
// ./src/js/partials/format-hero-tagline.js